import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Bukalapak: React.FC<IconProps> = ({ size, style, color }) => {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? '20'}
      height={size ?? '21'}
      fill="none"
      viewBox="0 0 20 20"
      data-testid="bukalapak-icon"
    >
      <g clipPath="url(#ara)">
        <path
          fill={color ?? '#E31E52'}
          fillRule="evenodd"
          d="M8.81 10.82 6.535 1.46a1.962 1.962 0 0 0-.34-.705c-.16-.21-.36-.385-.59-.51-.23-.13-.485-.21-.745-.235-.26-.025-.525 0-.78.085l-2.455.8c-.25.08-.48.215-.68.39-.2.175-.355.39-.47.625-.11.235-.175.495-.18.76-.005.265.04.525.14.77L4.1 12.345a1.924 1.924 0 0 0 2.37 1.1l1.07-.35c.46-.15.845-.47 1.08-.89.235-.42.3-.92.185-1.39l.005.005Zm.34 9.055a2.64 2.64 0 0 1-1.525.03 2.639 2.639 0 0 1-1.895-2.22c-.06-.515.03-1.04.265-1.5a2.633 2.633 0 0 1 2.545-1.43c.52.04 1.01.23 1.42.555.41.32.715.755.875 1.25a2.617 2.617 0 0 1-.155 2.01 2.64 2.64 0 0 1-.635.81c-.265.225-.57.395-.9.5l.005-.005Zm5.46-2.405c3.375-1.095 6.095-4.985 4.74-9.155-1.355-4.165-5.845-5.715-9.215-4.62a1.59 1.59 0 0 0-.89.73c-.195.35-.25.755-.155 1.14l.34 1.4c.05.21.145.41.28.58a1.568 1.568 0 0 0 1.74.54l.14-.045c.335-.12.69-.17 1.04-.15.355.02.7.11 1.015.27a2.636 2.636 0 0 1 1.35 1.56 2.647 2.647 0 0 1-1.77 3.36l-.14.045a1.508 1.508 0 0 0-.555.32c-.16.145-.29.32-.385.515-.09.195-.14.41-.145.625 0 .215.035.43.115.63l.545 1.335a1.577 1.577 0 0 0 1.945.905l.005.015Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="ara">
          <path fill="#fff" d="M.295 0h19.41v20H.295z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Bukalapak;
